import React from 'react';
import { Text } from '@input';
import { keys } from '@enums';

function ZipCode(props) {
  return (
    <Text
      label="Zip Code"
      className="input-zip-code"
      fieldClassName="field-zip-code"
      name={keys.ZIP_CODE}
      format="#####"
      mask=""
      hasError={props.hasError}
      maxWidth={90}
      valueIsNumericString
      disableArrowKeyIncrement
      autoComplete="off"
      data-1p-ignore
      {...props}
    />
  );
}

function validate(zipCode) {
  zipCode = String(zipCode);

  if (!zipCode?.match(/^\d{5}$/)) {
    return 'Please enter a valid zip code';
  }
}

export default { Component: ZipCode, validate };
